'use client';
import { Box } from '@mui/material';
import { CardsType } from '../type';
import TextCard from '../grid/TextCard';
import DarkThemeProvider from '../../../../providers/DarkThemeProvider';
import LightThemeProvider from '../../../../providers/LightThemeProvider';
import useIsMobile from '../../../../utils/useIsMobile';
import ArrowScrollContainer from './ArrowScrollContainer';

type Props = {
  data: CardsType;
  isMobile: boolean;
};

const CARD_WIDTH = { xs: '80vw', sm: '360px', md: '340px' };

const ScrollableCards = ({ data, isMobile: initIsMobile }: Props) => {
  const { cards, styling, orientation = 'vertical', role, showArrowsOn } = data;
  const isMobile = useIsMobile(initIsMobile);
  const ThemeProvider = styling.isDark ? DarkThemeProvider : LightThemeProvider;

  const showArrows =
    showArrowsOn === 'both' ||
    (showArrowsOn === 'mobile' && isMobile) ||
    (showArrowsOn === 'desktop' && !isMobile);

  return (
    <ThemeProvider>
      <ArrowScrollContainer showArrows={showArrows}>
        {cards.map((card) => (
          <Box
            key={card.id}
            sx={{ flex: '0 0 auto', width: CARD_WIDTH, scrollSnapAlign: 'start' }}
          >
            <TextCard
              orientation={orientation}
              variant="static"
              isMobile={isMobile}
              moveAuthorTop={styling.listContainer.moveAuthorTop}
              moveTagsTop={styling.listContainer.moveTagsTop}
              {...card}
              role={role}
              sx={styling.sx}
              imageSx={styling.imageSx}
            />
          </Box>
        ))}
      </ArrowScrollContainer>
    </ThemeProvider>
  );
};

export default ScrollableCards;
